export const filterIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21.8 2.1A1 1 0 0 0 21 .5H2.981a1 1 0 0 0-.8 1.6l7.808 10.491V22.5a1 1 0 0 0 1.6.8l2-1.5a1 1 0 0 0 .4-.8v-8.41Z" style="fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round"/></svg>`,
    name: 'filter'
};